import { render } from "./CardMetafields.vue?vue&type=template&id=7662c066&ts=true"
import script from "./CardMetafields.vue?vue&type=script&lang=ts"
export * from "./CardMetafields.vue?vue&type=script&lang=ts"

import "./CardMetafields.vue?vue&type=style&index=0&id=7662c066&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__